
export { localStorageUtils } from "/codebuild/output/src3838206175/src/packages/utils/src/storage/index.ts"